import React from "react";
import models from "@aeo/core/models";

export const ApplicationPathContext = React.createContext<
  models.ApplicationValidatePath | undefined
>(undefined);
